import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class FolderTypeService {
  invokeFirstComponentFunction = new EventEmitter(); 
  private headers: HttpHeaders = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
  }
  
  getAllFolderType() {
    return this.http.get<any>('DocumentType/GetAllDocumentType')
  }

  getFolderTypeFolderId(folderId) {
    return this.http.get<any>('DocumentType/GetDocumentTypeByDocumentId?FolderTypeId= ' + folderId)
  }

  getAllActiveFolderType() {
    return this.http.get<any>('DocumentType/GetAllActiveDocumentType')
  }

  addEditFolderType(data) {
    return this.http.post<any>('DocumentType/AddEditDocumentType', data)
  }

  deleteFolderType(id, isDelete) {
    return this.http.get<any>('DocumentType/DeleteDocumentType?FolderTypeId=' + id + '&isDelete=' + isDelete)
  }

  getFolderTypeByEntityAndJobId(entityTypeId, jobTypeId) {
    return this.http.get<any>('DocumentType/GetDocumentTypeByEntityAndJobTypeId?entityTypeId=' + entityTypeId + '&jobTypeId=' + jobTypeId)
  }

  getAllJobTypeAndTaskType() {
    return this.http.get<any>('Document/getAllJobTypeAndTaskType')
  }

  UpdateStauts(Id, Type, Status) {
    return this.http.get<any>('Job/UpdateStauts?Id=' + Id + '&Type=' + Type + '&Status=' + Status)
  }

  onFirstComponentButtonClick() {
    this.invokeFirstComponentFunction.emit();
  }

  GetJobTypewithStatusById(JobTypeId) {
   return this.http.get<any>('Job/GetJobStatusforJtype/?JobTypeId=' + JobTypeId + '', { headers: this.headers })
  }

  AddOrUpdateTaskType(task) {
    return this.http.post<any[]>('Task/AddEditTaskType', task, { headers: this.headers });
  }

  getAllTaskType() {
    return this.http.get<any>('Task/GetTaskTypeList')
  }

  GetTaskTypeId(TaskTypeId) {
    return this.http.get<any>('Task/GetTaskTypeById?TaskTypeId=' + TaskTypeId)
  }

  UpdateaskTypeStauts(Id,Status) {
    return this.http.post<any>('Task/UpdateTaskTypestatus?TaskTypeId=' + Id + '&IsArchived=' + Status, { headers: this.headers })
  }

  AddOrUpdateJobTemplate(jobTemplate) {
    return this.http.post<any>('Job/AddEditJobTemplate', jobTemplate, { headers: this.headers });
  }

  deleteTaskTemplate(taskId) {
    return this.http.post<any>('Task/DeleteTaskTemplate?taskId=' + taskId, { headers: this.headers });
  }

  getAllJobTemplate() {
    return this.http.get<any>('Job/GetJobTemplateList');
  }

  GetJobTemplateId(TemplateId) {
    return this.http.get<any>('Job/GetJobTemplateById?TemplateId=' + TemplateId)
  }

  UpdateTemplateStatus(templateId,Status) {
    return this.http.post<any>('Job/UpdateJobTemplatestatus?TemplateId=' + templateId + '&IsDeactivate=' + Status, { headers: this.headers })
  }

  DeleteJobTemplateStatus(templateId, isDeleted) {
    return this.http.get<any>('Job/DeleteJobTemplate?TemplateId=' + templateId + '&DeletedFlag=' + isDeleted);
  }
  
  AddOrUpdateJobTypewithStatus(jobType) {
    return this.http.post<any[]>('Job/PostJobTypeswithStatus', jobType, { headers: this.headers });
  }
  
  AddEditTaskTemplate(templatetask) {
    return this.http.post<any>('Task/AddEditTemplateTask', templatetask, { headers: this.headers });
  }

  AddEditTemplateTaskGroup(templatetask) {
    return this.http.post<any>('Task/AddEditTemplateTaskGroup', templatetask, { headers: this.headers });
  }

  GetAllTemplatebTaskGroupbyTemplateId(templateId) {
    return this.http.get<any>('Task/GetAllTemplateTaskGroupbyId?templateId=' + templateId);
  }

  GetAllTemplateTaskGroupTemplateId(templateId) {
    return this.http.get<any>('Task/GetTemplateDetailWithGroups?templateId=' + templateId);
  }

  GetTemplateDetailWithGroups(templateId) {
    return this.http.get<any>('Task/GetTemplateDetailWithGroups?templateId=' + templateId);
  }

  getTaskDependenciesForTemplate(templateId, taskId){
    return this.http.get<any>('Task/GetTemplateTaskDependencies/'+templateId+'/'+taskId);
  }
  getTaskDependenciesForJob(contextId, taskId){
    return this.http.get<any>('Job/GetTaskDependencies/'+contextId+'/Job/'+taskId);
  }

  addEditDependencies(templateId: number, taskId: number, taskDependencyInfoJson: any[]) {
    const params = new HttpParams()
      .set('templateId', templateId.toString())
      .set('taskId', taskId.toString())
      .set('taskDependencyInfoJson', JSON.stringify(taskDependencyInfoJson)); 

    return this.http.post<any>('Task/AddEditDependenciesForTemplate', null, { params });
  }

  addEditDependenciesForJob(contextId: number, taskId: number, taskDependencyInfoJson: any[]) {
    const params = new HttpParams()
      .set('contextId', contextId.toString())
      .set('contextType', 'Job')
      .set('taskId', taskId.toString())
      .set('taskDependencyInfoJson', JSON.stringify(taskDependencyInfoJson)); 

    return this.http.post<any>('Job/AddEditTaskDependenciesForJob', null, { params });
  }

  addEditAutomationTemplate(data) {
    return this.http.post<any[]>('ProcessAutomation/AddEditAutomationTemplate', data, { headers: this.headers });
  }

  addEditJobAutomation(data) {
    return this.http.post<any[]>('ProcessAutomation/AddEditJobAutomation', data, { headers: this.headers });
  }

  getTemplateAutomations(){
    return this.http.get<any>('ProcessAutomation/AutomationEventTemplates');
  }

  updateAutomationStatus(automationEventId, status){
    return this.http.post<any>('ProcessAutomation/UpdateAutomationTemplateStatus?automationEventId=' + automationEventId + '&status=' + status +'',  { headers: this.headers });
  }

  getSelectedTemplateAutomationData(id){
    return this.http.get<any>('ProcessAutomation/AutomationEventTemplate?automationEventId='+id);
  }

  getSelectedJobAutomationData(id, jobId){
    return this.http.get<any>('ProcessAutomation/AutomationEventForJob?automationEventId='+id + '&jobId='+jobId);
  }

  deleteTemplateAutomation(automationEventId, isDeleted){
    return this.http.post<any>('ProcessAutomation/DeleteAutomationTemplate?automationEventId=' + automationEventId + '&isDeleted=' + isDeleted,  { headers: this.headers });
  }

  deleteJobAutomation(automationEventId, jobId, isDeleted){
    return this.http.post<any>('ProcessAutomation/DeleteJobAutomation?automationEventId=' + automationEventId + '&jobId=' + jobId + '&isDeleted=' + isDeleted,  { headers: this.headers });
  }
  getJobAutomations(id){
    return this.http.get<any>('ProcessAutomation/AutomationEventsForJob?jobId=' + id);
  }

  updateJobAutomationStatus(automationEventId, jobId, status){
    return this.http.post<any>('ProcessAutomation/UpdateJobAutomationStatus?automationEventId=' + automationEventId + '&jobId=' + jobId + '&status=' + status +'',  { headers: this.headers });
  }

   updateAutomationTemplateExecutionType(automationEventId, executionType){
    return this.http.post<any>('ProcessAutomation/UpdateAutomationTemplateExecutionType?automationEventId=' + automationEventId + '&executionType=' + executionType +'',  { headers: this.headers });
  }

  updateJobAutomationExecutionType(automationEventId, jobId, executionType){
    return this.http.post<any>('ProcessAutomation/updateJobAutomationExecutionType?automationEventId=' + automationEventId + '&jobId='+ jobId + '&executionType=' + executionType +'',  { headers: this.headers });
  }
}
